module.exports = __webpack_public_path__ + "img/volume-up.b04e9e2f.svg";